import {useNuxtApp} from '#app';
import {useUniversalFetch} from '#imports';

interface AllFFState {
    standard: Record<string, boolean>;
    hostBased: Record<string, boolean>;
}

export function useFeatureFlagApi() {
    const nuxtApp = useNuxtApp();

    /**
     *
     * @param featureFlagIds The feature flag IDs you want to check
     *
     * @example
     *
     * ```ts
     * const ffStates = await fetchFeatureFlags(['my-feature-flag-1', 'my-feature-flag-2']);
     * ```
     */
    async function fetchFeatureFlags<T extends string[] = []>(featureFlagIds: [...T] = [] as unknown as [...T]): Promise<AllFFState> {
        if (featureFlagIds.length === 0) {
            return {
                standard: {},
                hostBased: {},
            };
        }

        const ffList = featureFlagIds.join(',');

        return nuxtApp.runWithContext(() => useUniversalFetch<AllFFState>(`/api/feature-flipping/fetch-all/${ffList}`));
    }

    async function fetchFeatureFlag(featureFlagId: string): Promise<boolean> {
        return nuxtApp.runWithContext(() => useUniversalFetch<boolean>(`/api/feature-flipping/${featureFlagId}`));
    }

    return {
        fetchFeatureFlags,
        fetchFeatureFlag,
    };
}
